<template>
  <v-card flat>
    <v-card-text>
      <v-tabs
          v-model="tab"
          background-color="primary"
          color="basil"
          grow
          centered
          dark
          icons-and-text
      >
        <v-tab
            v-for="item in items"
            :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="Request Parameters"
        >
          <v-card>
            <v-card-title>Amend Beneficiary Details</v-card-title>
            <v-card-text>
              Upon onboarding of the beneficiary, we provide ability to amend the beneficiary details in cases where mistakes were made during onboarding. Kindly NOTE after details amendment, the beneficiary still goes through approval process to verify the amended details.
            </v-card-text>
            <v-divider/>
            <v-card-text>
              EndPoints:<br/>
              <div class="secondary pa-5" style="color: #e7e3fc">
                <strong>Sandbox</strong>
                <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/waas/beneficiary/update/"}}</p>
              </div>
            </v-card-text>
            <v-divider/>
            <v-card-text>
              Request Parameters <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon> Change <code>MerchantCode</code> to your <code>{{"MERCHANT_CODE"}}</code> <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>FirstName</code>  <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon> <code>MiddleName</code><br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>LastName</code> <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>MobileNumber</code> <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>DocumentType</code><br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>CountryCode</code> <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>MobileNumber</code> <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>Email</code> <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>DocumentNumber</code> <br/>
              <v-icon color="primary">mdi-access-point-check</v-icon>  <code>CallbackUrl</code> <br/>


            </v-card-text>
            <v-divider/>
            <v-card-text>
              Expected Results:<br/>

              Sasa<span class="red--text">Pay</span> returns the response status with a detailed message.
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item key="Sample Request"
        >
          <v-card
              color="basil"
              flat
          >
            <v-card-text>
              <code-editor
                  :read_only="true"
                  theme="dark"
                  v-model="code"
                  @lang="changeLanguage"
                  :wrap_code="false"
                  :language_selector="true"
                  class="github_dark"
                  :copy_code="true"
                  font_size="14px"
                  width="100%"
                  :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['javascript', 'Node Js']]"
              ></code-editor>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="Sample Response"
        >
          <v-card
              color="basil"
              flat
          >
            <v-card-text>
              <code-editor
                  :read_only="true"
                  theme="dark"
                  v-model="response"
                  :wrap_code="false"
                  :language_selector="true"
                  class="github_dark"
                  :copy_code="true"
                  font_size="14px"
                  width="100%"
                  :languages="[['json','JSON']]"
              ></code-editor>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>

import {
  amendBeneficiaryDetailsCodeResponse,
  amendBeneficiaryDetailsRequest
} from "../../../../../shared/snippets/waas/beneficiary/beneficiary";

export default {
  name: "AmendBeneficiary",
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
    tab: null,
    items: [
      'Request Parameters', 'Sample Request','Sample Response',
    ],
  }),
  mounted() {
    this.importSnippets('php')//
    this.importResponse()
  },
  methods:{
    importSnippets(lang){
      this.code=amendBeneficiaryDetailsRequest(lang)
    },
    importResponse(){
      this.response=amendBeneficiaryDetailsCodeResponse()
    },
    changeLanguage(val) {
      this.importSnippets(val)
    }
  }
}
</script>

<style scoped>

</style>